import { render, staticRenderFns } from "./DocumentCanvas.vue?vue&type=template&id=e55f2d58&scoped=true&"
import script from "./DocumentCanvas.vue?vue&type=script&lang=js&"
export * from "./DocumentCanvas.vue?vue&type=script&lang=js&"
import style0 from "./DocumentCanvas.vue?vue&type=style&index=0&id=e55f2d58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55f2d58",
  null
  
)

export default component.exports